// Importing the central gsap module registers all plugins (ScrollTrigger,
// TextPlugin, CustomEase, useGSAP) as a side effect. Rendering this component
// high in the layout tree guarantees registration happens eagerly on mount.
import '@utils/gsap'

export const GsapTriggers = () => {
  return null
}
